import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import InfiniteCalendar from 'react-infinite-calendar';
import Dialog from 'material-ui/Dialog';
import Checkbox from 'material-ui/Checkbox';
import Divider from 'material-ui/Divider';
import { connect } from 'react-redux';
import { loadProjectsFromFirebase, loadAdminProjectsFromFirebase, loadTasksFromFirebase, loadAdminTasksFromFirebase } from './components/project/project_actions';
import 'react-infinite-calendar/styles.css'; // only needs to be imported once
import DateRange from 'material-ui/svg-icons/action/date-range';
import firebaseApp from './firebase/firebase';
import {List, ListItem} from 'material-ui/List';
import {Card, CardHeader, CardText, CardTitle} from 'material-ui/Card';
import { convertSecondsToHoursMinutes } from './utilities/time';

var today = new Date();
var lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);

class Main extends Component {

  constructor() {
    super()
    this.state = {
      open: false,
    }
  }

  componentDidMount() {
    if (this.props.user.email === 'admin@mymozak.com'){
      this.props.loadAdminProjectsFromFirebase();
      this.props.loadAdminTasksFromFirebase();
    } else {
      this.props.loadProjectsFromFirebase();
      this.props.loadTasksFromFirebase();
    }
    firebaseApp.database().ref(`users/${this.props.user.uid}`).on('value', snapshot => {
      this.setState({ realtor: snapshot.val().meta.realtor, hours: snapshot.val().meta.hours })
    })
  }

  handleClose = () => {
    this.setState({open: false});
  };

  sortTimers = () =>{

  }

  render() {
    return (
      <div style={{ marginLeft: -17, marginRight: -17 }}>
        <Grid fluid style={{ marginTop: 10, marginBottom: 30 }}>
          <Row >
            <Col xs={12} sm={12} md={6} lg={4}>
              <Card style={{ backgroundColor: '#1565C0', marginTop: 10,  borderRadius: 10  }} onClick={() => this.setState({ open: true })}>
                <CardText style={{ color: 'white '}}>
                  <CardTitle title={this.props.count} style={{ textAlign: 'right' }} titleStyle={{ fontSize: 30,  color: 'white', fontWeight: 800 }}/>
                  <h3>Tasks Not Completed</h3>
                </CardText>
              </Card>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4}>
              <Card style={{ backgroundColor: '#37474F', marginTop: 10,  borderRadius: 10  }}>
                <CardText style={{ color: 'white '}}>
                  <CardTitle title={this.props.projectCount} style={{ textAlign: 'right' }} titleStyle={{ fontSize: 30,  color: 'white', fontWeight: 800 }}/>
                  <h3>Number of Homes</h3>
                </CardText>
              </Card>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4}>
              <Card style={{ backgroundColor: '#F2A512', marginTop: 10,  borderRadius: 10  }}>
                <CardText style={{ color: 'white '}}>
                  <CardTitle title={Math.round(this.state.hours / 60)} style={{ textAlign: 'right' }} titleStyle={{ fontSize: 30,  color: 'white', fontWeight: 800 }}/>
                  <h3>{this.state.realtor? 'Mozak Plan' : 'Total Time Worked'}</h3>
                </CardText>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12} lg={4}>
              <Card style={{ marginTop: 25,  borderRadius: 10  }}>
                <CardHeader
                  title={<div><DateRange style={{ width: 24, height: 24, color: '#2196F3', position: 'relative', top: 7}}/> Calendar </div>}
                  titleStyle={{ fontSize: 16, fontWeight: 400 }} />
                  <InfiniteCalendar
                      displayOptions={{
                        layout: 'portrait'
                      }}
                      theme={{headerColor: '#1565C0'}}
                      width={'100%'}
                      height={320}
                      selected={today}
                      disabledDays={[0,6]}
                      minDate={lastWeek}
                      autoFocus={false}
                    />
              </Card>
            </Col>
            <Col xs={12} sm={12} md={12} lg={8}>
             <Card style={{ marginTop: 25, borderRadius: 10}}>
              <CardHeader
                 title={<div><DateRange style={{ width: 24, height: 24, color: '#2196F3', position: 'relative', top: 7}}/> Property </div>}
                 titleStyle={{ fontSize: 16, fontWeight: 400 }} />
               <Divider />
               <CardText>
                 <iframe
                   width={'100%'}
                   height="450"
                   frameBorder="0" style={{ border: 0 }}
                   src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCPrnJ0JJj8gaIxgedZqLA3MZHDHXFJfvs
                     &q=627+Charleston+Ct,Memphis+TN" allowFullScreen>
                 </iframe>
               </CardText>
             </Card>
            </Col>
          </Row>
        </Grid>

        <Dialog
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
          >
                {
                  Object.keys(this.props.allTasks).map((date, i) => {
                    return (
                      <div key={i}>
                        <CardTitle title={`Due: ${date}`} titleStyle={{ fontSize: 18 }} />
                        <Divider />
                        {
                          Object.values(this.props.allTasks[date]).map((task, i) => {
                            return (
                              <List key={i}>
                                <ListItem
                                  innerDivStyle={{ marginTop: -10, marginBottom: -10}}
                                  primaryText={task}
                                  leftCheckbox={<Checkbox />}
                                  />
                              </List>
                            )
                          })
                        }
                      </div>
                    )
                  })
                }
        </Dialog>

      </div>
    );
  }
}

const mapStateToProps = ({ projects, auth }) => {
  const { allProjects, count, taskCount, allTasks, projectCount } = projects;
  const { user } = auth;
  return { allProjects, user, count, taskCount, allTasks, projectCount };
}




export default connect(mapStateToProps, { loadProjectsFromFirebase, loadAdminProjectsFromFirebase, loadTasksFromFirebase, loadAdminTasksFromFirebase })(Main);



// WEBPACK FOOTER //
// ./src/main.js